import moment from 'moment'

export const tradeTypeMapper = new Map([
  [1, '消费'],
  [2, '充值'],
])
export const tradeItemMapper = new Map([
  [1, 'OCR识别'],
  [2, '违章查询'],
])


function createSelectSource(mapper) {
  const arr = Array.from(mapper.keys()).map((key) => {
    return { label: mapper.get(key), value: key }
  })
  return [...arr]
}


export const layoutSearchFormItem = [
  {
    type: 'select',
    label: '交易类型',
    key: 'tradeType',
    // 消费、充值、提现、抵扣账单
    source: createSelectSource(tradeTypeMapper),
    options: {
      clearable: true,
    },
  },
  {
    type: 'select',
    label: '交易项目',
    key: 'tradeItems',
    // OCR识别、违章查询
    source: createSelectSource(tradeItemMapper),
    options: {
      clearable: true,
    },
  },
  {
    type: 'dateMonthPick',
    label: '交易日期',
    key: 'tradeDate',
    options: {
      rangeSeparator: '-',
      clearable: true,
    },
  },
]


function createTableColumn(key, label) {
  const _colums = {
    name: key,
    columnProps: {
      prop: key,
      label,
    },
  }
  if (key === 'tradeTime') {
    _colums.getText = ({ row }) => moment(row.tradeTime).format('YYYY-MM-DD HH:mm:ss')
  }
  return _colums
}
const tableColumnsMapper = new Map([
  ['tradeTime', '交易时间'],
  ['tradeType', '交易类型'],
  ['tradeItems', '交易项目'],
  ['operator', '操作人'],
  ['amount', '金额（元）'],
])
export const tableColumns = Array.from(tableColumnsMapper.keys()).map((key) => {
  return createTableColumn(key, tableColumnsMapper.get(key))
})
